// extracted by css-extract-rspack-plugin
export default {"modalHeader":"modalHeader-XLqn_e","modalHeaderIsSmall":"modalHeaderIsSmall-CHF5kD","modalHeaderIsWithDivider":"modalHeaderIsWithDivider-BUFOIP"};